// extracted by mini-css-extract-plugin
export default {"btn":"Keyboard_btn__hvz22","keyboard":"Keyboard_keyboard__vby92","inactive":"Keyboard_inactive__5BH2L"};